import {
    Container,
    Grid,
    Box,
    ButtonBase,
    makeStyles,
    Card,
    CardMedia,
    CardContent,
    useTheme,
    Slide,
    Typography,
    Hidden,
    useMediaQuery,IconButton,Snackbar,Tooltip,Fade 
  } from "@material-ui/core";
  import { useState, useEffect, useRef, useCallback } from "react";
  import parse from "react-html-parser";
  import MuiAlert from "@material-ui/lab/Alert";
  import Axios from "axios";
  import {Link, useParams} from 'react-router-dom';
  import { Helmet } from "react-helmet-async";
  import LinkIcon from '@material-ui/icons/Link';
  import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
  import ChevronRightIcon from '@material-ui/icons/ChevronRight';
  import "yet-another-react-lightbox/styles.css";
  import Lightbox from "yet-another-react-lightbox";
  import { Loading } from "../../components/shared/loading";
import { TypingQuote } from "../../components/shared/TypingQuote";
  
  import {
    EmailShareButton,
    EmailIcon,
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    LinkedinIcon,
    PinterestShareButton,
    PinterestIcon,
   // RedditShareButton,
   // RedditIcon,
    TelegramShareButton,
    TelegramIcon,
    TwitterShareButton,
    TwitterIcon,
   // ViberShareButton,
   XIcon,
    WhatsappShareButton,
    WhatsappIcon,
    RedditIcon,
    RedditShareButton
    
  } from "react-share";

  import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
  
  const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
  
  const useStyles = makeStyles((theme) => ({
    heroSection: {
      backgroundImage: 'linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.92)), url("/static/whats_new.jpg")',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "fixed",
      minHeight: "28vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    heroContent: {
      textAlign: "center",
      color: "#ffffff",
      padding: "36px 20px",
      maxWidth: 700,
    },
    heroDate: {
      fontSize: "0.72rem",
      fontWeight: 500,
      textTransform: "uppercase",
      letterSpacing: "1.5px",
      opacity: 0.7,
      marginBottom: 12,
    },
    heroTitle: {
      fontSize: "clamp(1.4rem, 3.5vw, 2rem)",
      fontWeight: 300,
      lineHeight: 1.3,
      marginBottom: 10,
    },
    heroDivider: {
      width: 40,
      height: 2,
      background: "rgba(255,255,255,0.4)",
      margin: "0 auto",
      borderRadius: 2,
    },
    pageWrapper: {
      background: "#f5f3f6",
      minHeight: "60vh",
      paddingTop: 0,
      paddingBottom: 60,
    },
    backLink: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      fontSize: "0.78rem",
      color: "#6b1b6b",
      fontWeight: 500,
      textDecoration: "none",
      padding: "20px 0 16px",
      transition: "all 0.2s ease",
      "&:hover": {
        textDecoration: "none",
        color: "#4c004c",
        gap: 10,
      },
    },
    articleContainer: {
      background: "#ffffff",
      borderRadius: 20,
      boxShadow: "0 8px 40px rgba(0,0,0,0.06)",
      overflow: "hidden",
    },
    // Gallery
    gallerySection: {
      position: "relative",
      width: "100%",
      background: "#0a0a0a",
      overflow: "hidden",
    },
    galleryMain: {
      position: "relative",
      width: "100%",
      height: 460,
      [theme.breakpoints.down('sm')]: {
        height: 300,
      },
      [theme.breakpoints.down('xs')]: {
        height: 240,
      },
    },
    gallerySlide: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0,
      transition: "opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "zoom-in",
    },
    gallerySlideActive: {
      opacity: 1,
      zIndex: 1,
    },
    galleryImage: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      border: "none",
      userSelect: "none",
    },
    galleryNav: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 3,
      backgroundColor: "rgba(255,255,255,0.1)",
      backdropFilter: "blur(8px)",
      color: "#ffffff",
      width: 44,
      height: 44,
      borderRadius: 14,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all 0.3s ease",
      border: "1px solid rgba(255,255,255,0.1)",
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.2)",
        transform: "translateY(-50%) scale(1.05)",
      },
      [theme.breakpoints.down('sm')]: {
        width: 36,
        height: 36,
        borderRadius: 10,
      },
    },
    galleryNavLeft: {
      left: 16,
      [theme.breakpoints.down('sm')]: {
        left: 10,
      },
    },
    galleryNavRight: {
      right: 16,
      [theme.breakpoints.down('sm')]: {
        right: 10,
      },
    },
    galleryCounter: {
      position: "absolute",
      top: 16,
      right: 16,
      background: "rgba(0,0,0,0.5)",
      backdropFilter: "blur(8px)",
      borderRadius: 10,
      padding: "6px 14px",
      zIndex: 3,
      [theme.breakpoints.down('sm')]: {
        top: 10,
        right: 10,
        padding: "4px 10px",
      },
    },
    galleryCounterText: {
      fontSize: "0.7rem",
      fontWeight: 500,
      color: "rgba(255,255,255,0.8)",
      letterSpacing: "0.5px",
    },
    galleryExpand: {
      position: "absolute",
      bottom: 16,
      right: 16,
      background: "rgba(255,255,255,0.1)",
      backdropFilter: "blur(8px)",
      borderRadius: 10,
      padding: "8px 14px",
      zIndex: 3,
      cursor: "pointer",
      transition: "all 0.2s ease",
      border: "1px solid rgba(255,255,255,0.1)",
      display: "flex",
      alignItems: "center",
      gap: 6,
      "&:hover": {
        background: "rgba(255,255,255,0.2)",
      },
      [theme.breakpoints.down('sm')]: {
        bottom: 10,
        right: 10,
        padding: "6px 10px",
      },
    },
    galleryExpandText: {
      fontSize: "0.68rem",
      fontWeight: 500,
      color: "rgba(255,255,255,0.85)",
      letterSpacing: "0.3px",
    },
    // Progress bar instead of dots
    galleryProgress: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: 3,
      background: "rgba(255,255,255,0.1)",
      zIndex: 3,
    },
    galleryProgressBar: {
      height: "100%",
      background: "linear-gradient(90deg, #9b3b9b, #6b1b6b)",
      borderRadius: "0 2px 2px 0",
      transition: "width 0.4s ease",
    },
    // Thumbnails
    thumbStrip: {
      padding: "14px 24px",
      background: "#0a0a0a",
      [theme.breakpoints.down('sm')]: {
        padding: "10px 16px",
      },
    },
    thumbScroll: {
      display: "flex",
      gap: 8,
      overflowX: "auto",
      paddingBottom: 4,
      "&::-webkit-scrollbar": {
        height: 0,
      },
    },
    thumb: {
      minWidth: 64,
      height: 48,
      objectFit: "cover",
      borderRadius: 8,
      cursor: "pointer",
      transition: "all 0.25s ease",
      border: "2px solid transparent",
      opacity: 0.5,
      filter: "brightness(0.7)",
      "&:hover": {
        opacity: 0.8,
        filter: "brightness(0.9)",
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 50,
        height: 38,
        borderRadius: 6,
      },
    },
    thumbActive: {
      opacity: 1,
      filter: "brightness(1)",
      borderColor: "#9b3b9b",
    },
    // Share
    shareBar: {
      padding: "16px 28px",
      display: "flex",
      alignItems: "center",
      gap: 10,
      borderBottom: "1px solid rgba(76,0,76,0.06)",
      [theme.breakpoints.down('sm')]: {
        padding: "14px 20px",
        gap: 8,
      },
    },
    shareLabel: {
      fontSize: "0.72rem",
      fontWeight: 600,
      color: "#999",
      textTransform: "uppercase",
      letterSpacing: "1px",
      marginRight: 4,
    },
    shareBtn: {
      transition: "all 0.2s ease",
      opacity: 0.7,
      "&:hover": {
        opacity: 1,
        transform: "scale(1.12)",
      },
    },
    // Article Content
    articleContent: {
      padding: "36px 32px 40px",
      [theme.breakpoints.down('sm')]: {
        padding: "28px 20px 32px",
      },
    },
    articleBody: {
      fontSize: "0.95rem",
      color: "#2a2a2a",
      lineHeight: 1.9,
      fontWeight: 400,
      "& p": {
        marginBottom: 20,
      },
      "& img": {
        maxWidth: "100%",
        borderRadius: 12,
        margin: "24px 0",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      },
      "& h1, & h2, & h3, & h4": {
        color: "#4c004c",
        fontWeight: 600,
        marginTop: 32,
        marginBottom: 14,
      },
      "& a": {
        color: "#6b1b6b",
        textDecoration: "none",
        borderBottom: "1px solid rgba(107,27,107,0.3)",
        transition: "border-color 0.2s ease",
        "&:hover": {
          borderColor: "#6b1b6b",
        },
      },
      "& blockquote": {
        borderLeft: "3px solid #6b1b6b",
        margin: "24px 0",
        padding: "12px 20px",
        background: "rgba(107,27,107,0.03)",
        borderRadius: "0 8px 8px 0",
        fontStyle: "italic",
        color: "#555",
      },
      "& ul, & ol": {
        paddingLeft: 24,
        marginBottom: 20,
      },
      "& li": {
        marginBottom: 8,
      },
    },
    // Quote
    quoteSection: {
      background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
      borderRadius: 20,
      padding: "36px 28px",
      marginTop: 32,
      textAlign: "center",
      position: "relative",
      overflow: "hidden",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "radial-gradient(circle at 20% 80%, rgba(255,255,255,0.08) 0%, transparent 50%)",
        pointerEvents: "none",
      },
    },
    quoteText: {
      fontSize: "0.92rem",
      color: "#ffffff",
      lineHeight: 1.7,
      fontStyle: "italic",
      maxWidth: 650,
      margin: "0 auto 14px",
      position: "relative",
      zIndex: 1,
    },
    quoteAuthor: {
      color: "#ffffff",
      fontSize: "0.78rem",
      fontWeight: 600,
      opacity: 0.85,
      position: "relative",
      zIndex: 1,
    },
  }));

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  
  
  export const SingleArticle = () => {
    const params = useParams();
    const id = params.id;
    const theme = useTheme();
    const url=window.location.href;
    const isMatch = useMediaQuery(theme.breakpoints.down("md"));
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [metaTitle, setMetaTitle] = useState("");

    const [snackBar, setSnackBar] = useState(false);
    const [snackBarMsg, setSnackBarMsg] = useState("success");
    const [snackBarType, setSnackBarType] = useState("Invalid");
  
    const openSnkbar = (type, msg) => {
      setSnackBarMsg(msg);
      setSnackBarType(type);
      setSnackBar(true);
    };
  
  const [open1, setOpen1] = useState(false);
    const [isloading, setIsloading] = useState(true);
    const [tooSlideImages, setTooSlideImages] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);
    const autoPlayRef = useRef(null);
  
    const [closeOnPullDown, setCloseOnPullDown] = useState(true);
    const [closeOnBackdropClick, setCloseOnBackdropClick] = useState(true);

    // Get images array
    const getImages = useCallback(() => {
      if (data && data.article_images) {
        return data.article_images.split(",");
      }
      return [];
    }, [data]);

    // Auto-slide effect
    useEffect(() => {
      const images = getImages();
      if (images.length > 1 && isAutoPlaying && !isloading) {
        autoPlayRef.current = setInterval(() => {
          setCurrentSlide((prev) => (prev + 1) % images.length);
        }, 4000);
      }
      return () => {
        if (autoPlayRef.current) {
          clearInterval(autoPlayRef.current);
        }
      };
    }, [getImages, isAutoPlaying, isloading]);

    // Navigation functions
    const goToSlide = (index) => {
      setCurrentSlide(index);
      setIsAutoPlaying(false);
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    const nextSlide = () => {
      const images = getImages();
      setCurrentSlide((prev) => (prev + 1) % images.length);
      setIsAutoPlaying(false);
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    const prevSlide = () => {
      const images = getImages();
      setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
      setIsAutoPlaying(false);
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    // Open lightbox starting from current slide
    const openLightbox = () => {
      const images = getImages();
      const reorderedImages = [...images.slice(currentSlide), ...images.slice(0, currentSlide)];
      setTooSlideImages(reorderedImages);
      setOpen1(true);
    };

    const handleClick = () => {
      const anchor = document.querySelector("#back-to-top-anchor");
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    const [tooltipText, setTooltipText] = useState("Click to copy the URL");

  const handleCopy = () => {
    // Copy the URL to clipboard
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        setTooltipText("Link copied to clipboard!"); // Update tooltip text
        setTimeout(() => setTooltipText("Click to copy the URL"), 2000); // Reset tooltip text after 2 seconds
      })
      .catch((err) => console.error("Failed to copy: ", err));
  };
  
    useEffect(() => {
      getMetaData();
    }, []);
  
    const getMetaData = async() => {
        const formdata = new FormData();
        formdata.append("article_id", id);
        Axios
          .post("/api/get_single_article", formdata)
          .then((res) => {
            console.log(res.data.data);
            if (res.data.status === true) {
              setMetaTitle(res.data.data.article_title);
              setData(res.data.data);
              handleClick();
              setIsloading(false);
            }
          }) ;
    };
  
 
  // Function to handle click on any image (other than the first) and open a lightbox with a specific starting index.
  const handleImageClick = (index) => {
    var slideImages = data.article_images.split(",");
    // Rearrange the images array to start from the clicked index and set it for the lightbox.
    var shiftImages = slideImages.splice(0, index + 1);
    slideImages.push(...shiftImages);
    // Set the images for the lightbox and open it.
    setTooSlideImages(slideImages);
    setOpen1(true);
     
  };

   
  
    return (
      <div>
        <Helmet>
          <title>{metaTitle}</title>
           
        </Helmet>
         
       
        {isloading ? (
          <Loading />
        ) : (
          <>
          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <Fade in={true} timeout={1000}>
              <Box className={classes.heroContent}>
                <Typography className={classes.heroDate}>
                  {data.article_published_date}
                </Typography>
                <Typography className={classes.heroTitle}>
                  {data.article_title}
                </Typography>
                <Box className={classes.heroDivider} />
              </Box>
            </Fade>
          </Box>

          <Box className={classes.pageWrapper}>
            <Container maxWidth="md">
              {/* Back Link */}
              <Link to="/whats-new" className={classes.backLink}>
                ← Back to What's New
              </Link>

              {/* Lightbox */}
              {open1 && (
                <Lightbox
                  open={open1}
                  close={() => setOpen1(false)}
                  slides={tooSlideImages.map((src, index) => ({
                    src: `/static/articles/${src}`,
                    index,
                  }))}
                  controller={{ closeOnPullDown, closeOnBackdropClick }}
                  render={{
                    buttonPrev: tooSlideImages.length > 1 ? undefined : () => null,
                    buttonNext: tooSlideImages.length > 1 ? undefined : () => null,
                  }}
                />
              )}

              {/* Article Card */}
              <Box className={classes.articleContainer}>
                {/* Image Gallery */}
                <Box className={classes.gallerySection}>
                  <Box className={classes.galleryMain}>
                    {getImages().map((img, index) => (
                      <Box
                        key={index}
                        className={`${classes.gallerySlide} ${index === currentSlide ? classes.gallerySlideActive : ''}`}
                        onClick={openLightbox}
                      >
                        <img
                          src={`/static/articles/${img}`}
                          alt={`${data.article_title} ${index + 1}`}
                          className={classes.galleryImage}
                        />
                      </Box>
                    ))}

                    {/* Nav Arrows */}
                    {getImages().length > 1 && (
                      <>
                        <Box 
                          className={`${classes.galleryNav} ${classes.galleryNavLeft}`}
                          onClick={(e) => { e.stopPropagation(); prevSlide(); }}
                        >
                          <ChevronLeftIcon style={{ fontSize: 20 }} />
                        </Box>
                        <Box 
                          className={`${classes.galleryNav} ${classes.galleryNavRight}`}
                          onClick={(e) => { e.stopPropagation(); nextSlide(); }}
                        >
                          <ChevronRightIcon style={{ fontSize: 20 }} />
                        </Box>
                      </>
                    )}

                    {/* Image Counter */}
                    {getImages().length > 1 && (
                      <Box className={classes.galleryCounter}>
                        <Typography className={classes.galleryCounterText}>
                          {currentSlide + 1} / {getImages().length}
                        </Typography>
                      </Box>
                    )}

                    {/* Expand Button */}
                    <Box className={classes.galleryExpand} onClick={openLightbox}>
                      <Typography className={classes.galleryExpandText}>
                        View Full
                      </Typography>
                    </Box>

                    {/* Progress Bar */}
                    {getImages().length > 1 && (
                      <Box className={classes.galleryProgress}>
                        <Box 
                          className={classes.galleryProgressBar} 
                          style={{ width: `${((currentSlide + 1) / getImages().length) * 100}%` }} 
                        />
                      </Box>
                    )}
                  </Box>

                  {/* Thumbnail Strip */}
                  {getImages().length > 1 && (
                    <Box className={classes.thumbStrip}>
                      <Box className={classes.thumbScroll}>
                        {getImages().map((img, index) => (
                          <img
                            key={index}
                            src={`/static/articles/${img}`}
                            alt={`Thumbnail ${index + 1}`}
                            className={`${classes.thumb} ${index === currentSlide ? classes.thumbActive : ''}`}
                            onClick={() => goToSlide(index)}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>

                {/* Share Bar */}
                <Box className={classes.shareBar}>
                  <Typography className={classes.shareLabel}>Share</Typography>
                  <FacebookShareButton url={url} className={classes.shareBtn}>
                    <FacebookIcon size={26} round />
                  </FacebookShareButton>
                  <LinkedinShareButton url={url} className={classes.shareBtn}>
                    <LinkedinIcon size={26} round />
                  </LinkedinShareButton>
                  <TwitterShareButton url={url} className={classes.shareBtn}>
                    <XIcon size={26} round />
                  </TwitterShareButton>
                  <WhatsappShareButton url={url} className={classes.shareBtn}>
                    <WhatsappIcon size={26} round />
                  </WhatsappShareButton>
                  <TelegramShareButton url={url} className={classes.shareBtn}>
                    <TelegramIcon size={26} round />
                  </TelegramShareButton>
                  <EmailShareButton url={url} className={classes.shareBtn}>
                    <EmailIcon size={26} round />
                  </EmailShareButton>
                  <Tooltip title={tooltipText} arrow>
                    <IconButton onClick={handleCopy} size="small" style={{ opacity: 0.6 }}>
                      <LinkIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* Article Content */}
                <Box className={classes.articleContent}>
                  <Box className={classes.articleBody}>
                    {parse(data.article_desc)}
                  </Box>
                </Box>
              </Box>

              {/* Quote Section */}
              <Box className={classes.quoteSection}>
                <TypingQuote
                  text={`"At Arawinz Soft Solutions, we are at the forefront, crafting the future. Each update is a testament to our journey towards excellence, transforming ideas into cutting-edge solutions."`}
                  className={classes.quoteText}
                />
                <Typography className={classes.quoteAuthor}>
                  — Dr. P. Srinivas Rao, CEO
                </Typography>
              </Box>

              {/* Snackbar */}
              <Snackbar
                open={snackBar}
                autoHideDuration={4000}
                onClose={() => setSnackBar(false)}
              >
                <Alert
                  onClose={() => setSnackBar(false)}
                  severity={snackBarType}
                  style={{ color: snackBarType === "warning" ? "black" : "white" }}
                >
                  {snackBarMsg}
                </Alert>
              </Snackbar>
            </Container>
          </Box>
          </>
        )}
     
      </div>
    );
  };
  

